import { preventBodyScroll } from '../core/helper-functions'

module.exports = {
  props: ['dedication', 'name', 'translation', 'lang', 'isedit'],
  data () {
    return {
      visible: false,
      temporaryDedication: this.dedication,
      isAgree: true,
      rows: 1
    }
  },
  computed: {
    characterCount () {
      return 256 - this.temporaryDedication.length
    },
    isDisabled () {
      return !this.isAgree || this.temporaryDedication.trim() === ''
    }
  },

  created () {
    this.rows = this.dedication.split('\n').length
    this.temporaryDedication = this.dedication || ''
  },

  methods: {
    open () {
      this.visible = true
      preventBodyScroll(true)
    },

    close () {
      this.visible = false
      preventBodyScroll(false)
    },

    reload () {
      window.location.reload()
    },

    counterRows (e) {
      this.rows = this.temporaryDedication.split('\n').length

      if (e.keyCode === 13) {
        if (this.rows >= 6)  {
          e.preventDefault()
        } else {
          this.rows++
        }
      }
    },

    next () {
      this.$emit('update:dedication', this.temporaryDedication)
      this.$emit('save-order')

      if (this.isedit) {
        const args = { cb: this.reload, updateDedication: true }
        this.dedication !== this.temporaryDedication ? this.$emit('add-to-cart', args) : this.close()
      } else {
        this.close()
        this.$emit('open')
      }
    }
  },

  template: `
    <div class="relative">
      <div @click="open">
        <slot name="reference"></slot>
      </div>
      <transition name="fade">
        <div v-if="visible" @click="close" class="hero-modal p-md-4 text-md-left d-flex justify-content-center align-items-center">
          <div @click.stop class="overflow-y-auto h-100">
            <div class="hero-modal__dedication relative">
              <p @click="close" class="h-pointer hero-modal__close h-text-grey-cl-450 d-flex align-items-center"><span class="mr-2">close</span> <i class="icon-close"></i></p>
              <img class="hero-modal__dedication__image" src="/static/personal_book_app/img/home/dedication.jpg" alt="dedication">
              <div class="p-3 p-md-4">
                <h2 class="heading-4 m-0 h-text-grey-cl-900 h-font-barlow font-weight-bold">{{translation['Custom Dedication']}}</h2>
                <p class="h-text-grey-cl-900 mb-4">{{translation['Write your own personalized dedication for']}} {{ name }} {{translation['and we will print it on the first page.']}}</p>
                <div class="relative">
                  <textarea @keypress="counterRows($event)" class="hero-modal__textarea" rows="7" ref="textarea" maxlength="256" placeholder="Happy birthday to our little star! Grandpa and I love you very much and hope all your wildest dreams come true. \n \nLots of love from your biggest fans." v-model="temporaryDedication"></textarea>
                  <p class="hero-modal__characters title-11 h-text-grey-cl-450 font-weight-bold">{{ characterCount }} {{translation['character remaining']}}</p>
                </div>
                <checkbox v-model="isAgree" class="mb-4 mt-3 title-8 h-text-grey-cl-400">{{translation['Check here']}} <a target="_blank" :href="'/' + lang + '/terms-and-conditions/'" class="h-text-primary-cl">{{translation['Terms of Service']}}</a> {{translation['and']}} <a target="_blank" :href="'/' +lang + '/privacy-policy/'" class="h-text-primary-cl">{{translation['Privacy Policy']}}</a></checkbox>
                <div class="d-flex justify-content-center justify-content-md-end">
                  <p @click.stop="next" class="main-btn main-btn--green-light" :disabled="isDisabled">{{translation['Next']}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  `
}